import * as React from 'react';
import { Link } from "react-router-dom"
import { Button } from "@progress/kendo-react-buttons";
import { AppUserContext } from '../components/PvsContextProvider';
import SubmittedKitList from '../pages/submittedKit/SubmittedKit_List';
import ReportList from '../pages/reports/Report_List';

export const Dashboard = () => {
    const appUserContext = React.useContext(AppUserContext);

    return (
        <>
            <div className="greeting">
                Hello again, {appUserContext.appUser?.Name}!
            </div>
            <br></br>
            <div style={{ width: "100%", height: "100%" }}>
                <div style={{ width: "850px", display: "inline-block", float: "left", marginRight: "5px" }}>
                    <span style={{ width: "100%", display: "inherit", marginBottom: "5px" }} className='s-k-flex-50 p-4 rounded-lg streck-secondary'>
                        <h1>Recently Submitted Kits</h1>
                        <SubmittedKitList narrowList={true}>
                        </SubmittedKitList>
                    </span>
                    <span style={{ width: "100%", display: "inherit" }} className='s-k-flex-50 p-4 rounded-lg streck-secondary'>
                        <h1>Recently Created Reports</h1>
                        <ReportList narrowList={true}>
                        </ReportList>
                    </span>
                </div>
                <div style={{ display: "float", float: "left", marginRight: "5px", position: "sticky", top: "0" }} className='s-k-flex-50 p-4 rounded-lg streck-secondary' >
                    <Link to="/submitted-kit-manage">
                        <Button className="">
                            Submit New Kit
                        </Button>
                    </Link>
                    <br></br>
                    <br></br>
                    <Link to="/lab-manage">
                        <Button className="">
                            Create New Lab
                        </Button>
                    </Link>
                    <br></br>
                    <br></br>
                    <Link to="/pipet-manage">
                        <Button className="">
                            Create New Pipet
                        </Button>
                    </Link>
                    <br></br>
                    <br></br>
                    <Link to="/operator-manage">
                        <Button className="">
                            Create New Operator
                        </Button>
                    </Link>
                    <br></br>
                    <br></br>
                    {(appUserContext.isStreckAdmin) &&
                        <>
                            <Link to="/barcode-import">
                                <Button className="">
                                    Import Barcode Lot
                                </Button>
                            </Link>
                            <br></br>
                            <br></br>
                            <Link to="/submitted-kit-list-processing">
                                <Button className="">
                                    Kits to Process
                                </Button>
                            </Link>
                            <br></br>
                            <br></br>
                            <Link to="/submitted-kit-list-review">
                                <Button className="">
                                    Kits to Review
                                </Button>
                            </Link>
                        </>
                    }
                </div>
            </div>
        </>
    );
};